<div class="footer" appFooterHeight>
  <div class="footer__inner l-wrapper">
    <ng-container >
      <div class="footer__subtitle h4" *ngIf="additionalAbout$ | async as additionalAbout">
        <a [routerLink]="['additional', additionalAbout.slug]" class="link link--th-ctrl link--underline-in" data-cy="about-link">{{ additionalAbout.menuLabel }}</a>
      </div>
    </ng-container>

    <div class="footer__social" *ngIf="socialLinks$ | async as socialLinks">
      <div class="footer__social-wrap">
        <a href="{{ link.url }}" *ngFor="let link of socialLinks"
           attr.aria-label="Navigate to {{ link.name }}" i18n-aria-label>
          <app-svg-icon
            [icon]="link.name"
            [width]="'26'"
            [height]="'26'"
            [clickable]="true"
            [additionalClass]="'secondary-color'"
          ></app-svg-icon>
        </a>
      </div>
    </div>

    <ng-container *ngIf="{
      personalDataPolicyPage: personalDataPolicyPage$ | async,
      additionalPrivacy: additionalPrivacy$ | async,
      fromRussia: fromRussia$ | async
    } as data"
    >
      <div class="footer__subtitle small" *ngIf="data.fromRussia && data.personalDataPolicyPage">
        <a
          [routerLink]="['additional', data.personalDataPolicyPage.slug]"
          class="link link--th-ctrl link--underline-in"
          data-cy="privacy-link"
          i18n="@@PrivacyPolicy"
        >
          Privacy policy
        </a>
      </div>
      <div class="footer__subtitle small" *ngIf="(!data.fromRussia || !data.personalDataPolicyPage) && data.additionalPrivacy">
        <a
          [routerLink]="['additional', data.additionalPrivacy.slug]"
          class="link link--th-ctrl link--underline-in"
          data-cy="privacy-link"
          i18n="@@PrivacyPolicy"
        >
          Privacy policy
        </a>
      </div>
    </ng-container>

    <div class="footer__dev small" *ngIf="(isIiko$ | async) !== null">
      <ng-container i18n="@@FooterCopyright">Developed on the platform</ng-container>
      {{ (isIiko$ | async) ? 'iiko' : 'Syrve' }}
    </div>
  </div>
</div>

<ng-template #metricView></ng-template>
